import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Pencil from '../../Icons/Pencil';
import BiButton from '../../biLogger/Components/BiButton';
import { BiEventType } from '../../biLogger/constants';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { DEFAULT_BACKGROUND_ID } from '../redux/constants';
import s from './BackgroundPicker.scss';
export var BackgroundPicker = function (_a) {
    var className = _a.className, deviation = _a.deviation, canSetCustomBackground = _a.canSetCustomBackground, firstTime = _a.firstTime, onInitialize = _a.onInitialize, showBackgroundPicker = _a.showBackgroundPicker, recordFirstTimeUse = _a.recordFirstTimeUse, _b = _a.currentBackgroundId, currentBackgroundId = _b === void 0 ? DEFAULT_BACKGROUND_ID : _b;
    var t = useTranslation().t;
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    if (!canSetCustomBackground) {
        return null;
    }
    return (React.createElement(BiButton, { className: classnames(s['trigger'], firstTime && s['FTUE'], className), onClick: function () {
            firstTime && recordFirstTimeUse();
            showBackgroundPicker(deviation);
        }, biData: {
            evid: BiEventType.CHANGE_BACKGROUND_CLICK,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation),
            background_id: currentBackgroundId,
        } },
        React.createElement(Pencil, { className: s['trigger-icon'] }),
        React.createElement("span", { className: s['trigger-text'] }, t('deviation.backgrounds.change'))));
};
export default BackgroundPicker;
//# sourceMappingURL=BackgroundPicker.js.map